var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 12,
    fill: "url(#paint0_linear_1_4122)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 59.5,
    height: 59.5,
    rx: 11.75,
    stroke: "#E6E6E6",
    strokeOpacity: 0.901961,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 12.5V16.105C20.76 17.61 17.61 20.76 16.0875 24.75H12.5V35.25H16.105C17.61 39.24 20.76 42.4075 24.75 43.9125V47.5H35.25V43.895C39.24 42.39 42.4075 39.24 43.9125 35.25H47.5V24.75H43.895C42.39 20.76 39.24 17.61 35.25 16.0875V12.5M28.25 16H31.75V19.5H28.25M24.75 19.9375V23H35.25V19.9375C37.315 21.005 38.995 22.685 40.0625 24.75H37V35.25H40.0625C38.995 37.315 37.315 38.995 35.25 40.0625V37H24.75V40.0625C22.685 38.995 21.005 37.315 19.9375 35.25H23V24.75H19.9375C21.005 22.685 22.685 21.005 24.75 19.9375ZM16 28.25H19.5V31.75H16M40.5 28.25H44V31.75H40.5M28.25 40.5H31.75V44H28.25",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4122",
    x1: 2.21774,
    y1: 30,
    x2: 60.121,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7445FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62D9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/integration.056a1dcb976e94dadf3433ee4f492cab.svg";
export { ForwardRef as ReactComponent };